import React from 'react';
import clsx from 'clsx';

const LabeledField = ({
  component,
  label,
  hideDivider = false,
  className = '',
}) => {
  return (
    <>
      {!hideDivider && <hr className='labeled-field_hr' />}
      <div className={clsx('labeled-field', className)}>
        <label className='labeled-field__label'>{label}</label>
        <div className='labeled-field__component'>{component}</div>
      </div>
    </>
  );
};

export default LabeledField;
